export default "assets/5cf3b5d5958df4083a31c32dbcbc149e.png";